module.exports = [
	"a11y_colors",
	"aa_marketplace",
	"ad_dash_notification_bell_nag",
	"additional_marketplace_listings",
	"advertising_dashboard_enabled",
	"aftership_shipment_tracking",
	"android_aa",
	"android_aa_1_q1_21",
	"android_aa_2_q1_21",
	"android_aa_3_q1_21",
	"android_aa_4_q1_21",
	"android_aa_5_q1_21",
	"android_autosuggest",
	"android_csp_filters",
	"android_csp_specs",
	"android_csp_within_search_results",
	"android_filters_ux",
	"android_homepage_affinities",
	"android_homepage_recency",
	"android_load_more",
	"android_rvp_logic",
	"android_search_filters_seller_location",
	"android_webview_login",
	"app_store_developer",
	"apple_pay_web",
	"bearer_v1_opt_out",
	"bearer_v_2_0",
	"best_seller_badge_v2",
	"blocked_from_flagging_listings",
	"braze_canvas_push",
	"braze_throttling",
	"bump_boost_similar_listings",
	"bump_from_core",
	"bump_sort_feed_digest",
	"buyer_free_shipping_threshold",
	"cms_exp_free_shipping",
	"covid_19_seller_email_notices",
	"create_custom_tax_policy",
	"csp_all_in_price_sort",
	"csp_card",
	"csp_dropdown_filters",
	"csp_search_ads",
	"csv_bump_recs",
	"dashboard_price_drop_report",
	"datadog_rum",
	"deals_filters",
	"defer_flyout_render",
	"disable_csv_imports",
	"disable_international_support_phones",
	"disable_push_webhook_worker",
	"disable_saved_search_emails",
	"disable_search_indexer_csp_updates",
	"disco_mosaic",
	"dummy",
	"email_offers",
	"execute_3ds",
	"expanded_csp_title",
	"facebook_api_v6",
	"feed_postgres_reads",
	"full_width_csp_row",
	"gear_collections",
	"gearnuts_import",
	"generic_csp_show_new",
	"google_auth",
	"grid_other_carts_nudge",
	"hidden_seller_sales",
	"hide_remove_from_cart_confirmation",
	"hide_search_header",
	"hide_whats_the_tax_text_intl",
	"hide_whats_the_tax_text_us",
	"i2_discount_font_size",
	"i2_sell_yours",
	"insurance_by_subcategory",
	"internal_gift_card_auto_approval",
	"ios_aa",
	"ios_aa_1_q1_21",
	"ios_aa_2_q1_21",
	"ios_aa_3_q1_21",
	"ios_aa_4_q1_21",
	"ios_aa_5_q1_21",
	"ios_affirm_callout",
	"ios_autosuggest",
	"ios_csp_filters",
	"ios_csp_specs",
	"ios_csp_within_results",
	"ios_filters_ux",
	"ios_homepage_affinities",
	"ios_search_load_more",
	"ios_search_refactor",
	"ios_webview_login",
	"item2_paid_landing",
	"item_logged_out_recently_viewed",
	"item_price_nudge_badge",
	"listing_card_location",
	"listing_description_flagging",
	"listing_lightbox_image",
	"logged_in_homepage_personalized_bump_row",
	"logged_out_popular_products",
	"login_verification",
	"looker_dash",
	"make_auctions",
	"marketplace_category_filter_row",
	"marketplace_multi_bump_row",
	"marketplace_query_suggestion",
	"marketplace_ssr",
	"marketplace_suggested_bump",
	"marketplace_trait_filters",
	"message_link_redirects",
	"mobile_native_redirects",
	"mobile_onboarding_redirect",
	"multiple_vat_numbers",
	"mv_dummy",
	"neo_marketplace",
	"new_bump_modal",
	"new_csp_row_title",
	"offer_quantity",
	"omit_legacy_css",
	"packlink",
	"product_preorders",
	"proximity_filter_marketplace",
	"quick_shipper_speed_nudge",
	"recent_search_suggestions",
	"recently_viewed_csps_2",
	"routing_number_validation_exception",
	"rre_throttle",
	"rule_of_100_price_display",
	"secondary_homepage_banner",
	"sell_button_cta",
	"sell_form_traits",
	"sell_search_increased_card_limit",
	"seller_affirm_promotion",
	"seller_auto_offer_ui",
	"separate_paypal_liable_account",
	"shipping_protection_seller_quote",
	"shop_bank_changes_require_unlocked_status",
	"shop_follower_tab",
	"show_more_csps_autocomplete",
	"show_reverb_sales_nag_banners",
	"show_subscriptions",
	"signature_optional_with_insurance",
	"site_search_recently_viewed",
	"store_shipment_tracking_notifications",
	"suggested_filters",
	"sunset_lp",
	"trait_facets",
	"uk_marketplace_vat_preview",
	"unmatched_item_similar_listings",
	"upc_required",
	"v2_automatching",
	"validate_android_attestation_token",
	"vat_verification_failure_email",
	"view_wip_locales",
	"warmup"
];


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/experiments.json
// module id = xvTg
// module chunks = 22 24 25